import axios from "axios";
import { toast } from "react-toastify";
import { dailyUpdateActions } from "../slices/dailyUpdateSlice";

// ----------------- Upsert My Daily Update -----------------
export function upsertMyDailyUpdateApi(payload) {
  return async (dispatch, getState) => {
    try {
      dispatch(dailyUpdateActions.startLoading());

      const token = getState().auth.user.token;

      const { data } = await axios.post(
        "https://remote-attendance.hsagroup.info/api/daily-updates",
        payload, // { date?, plan, done, blockers? }
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // backend returns: { message, dailyUpdate }
      dispatch(dailyUpdateActions.upsertMyDailyUpdate(data.dailyUpdate));
      toast.success(data.message || "Daily update saved");
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch(dailyUpdateActions.setError(message));
      toast.error(message);
      console.log(error);
    }
  };
}

// ----------------- Get My Daily Updates -----------------
export function getMyDailyUpdatesApi({ from, to } = {}) {
  return async (dispatch, getState) => {
    try {
      dispatch(dailyUpdateActions.startLoading());

      const token = getState().auth.user.token;

      const queryParams = new URLSearchParams();
      if (from) queryParams.append("from", from);
      if (to) queryParams.append("to", to);

      const url = queryParams.toString()
        ? `https://remote-attendance.hsagroup.info/api/daily-updates/me?${queryParams.toString()}`
        : "https://remote-attendance.hsagroup.info/api/daily-updates/me";

      const { data } = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      dispatch(dailyUpdateActions.setMyDailyUpdates(data || []));
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch(dailyUpdateActions.setError(message));
      toast.error(message);
      console.log(error);
    }
  };
}

// ----------------- Admin: Get Today Feed -----------------
export function getTodayDailyUpdatesApi() {
  return async (dispatch, getState) => {
    try {
      dispatch(dailyUpdateActions.startLoading());

      const token = getState().auth.user.token;

      const { data } = await axios.get(
        "https://remote-attendance.hsagroup.info/api/daily-updates/today",
        { headers: { Authorization: `Bearer ${token}` } }
      );

      dispatch(dailyUpdateActions.setTodayFeed(data));
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch(dailyUpdateActions.setError(message));
      toast.error(message);
      console.log(error);
    }
  };
}

// ----------------- Admin: Get Updates (All / Filtered) -----------------
export function getDailyUpdatesApi({ userId, from, to } = {}) {
  return async (dispatch, getState) => {
    try {
      dispatch(dailyUpdateActions.startLoading());

      const token = getState().auth.user.token;

      const queryParams = new URLSearchParams();
      if (userId) queryParams.append("userId", userId);
      if (from) queryParams.append("from", from);
      if (to) queryParams.append("to", to);

      const { data } = await axios.get(
        `https://remote-attendance.hsagroup.info/api/daily-updates?${queryParams.toString()}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Reuse todayFeed structure if you want, but simplest:
      dispatch(
        dailyUpdateActions.setTodayFeed({
          date: null,
          count: data?.length || 0,
          dailyUpdates: data || [],
        })
      );
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch(dailyUpdateActions.setError(message));
      toast.error(message);
      console.log(error);
    }
  };
}